import React from 'react';
import memoize from 'memoize-one';
import { useAbility } from '@casl/react';
import { Icon, ButtonTooltip } from '../../../components';
import { AbilityContext } from '../../../config/abilityContext';

const WorkflowActionButtons = ({ item, clickHandler, isOwnerView, currentEmployee }) => {
  const ability = useAbility(AbilityContext);
  const hasPermission = ability.can('workflow_action', 'OvertimeCompensationRequest');
  const canDestroy = ability.can('destroy', 'OvertimeCompensationRequest');

  const isCreator = item.employee_id === currentEmployee;

  const isMyTurn = isCreator && item.status === 'pending' && item.review_turn === true;

  const viewButton = (
    <ButtonTooltip
      onClick={() => clickHandler(item, 'show')}
      variant="circle-info"
      className="btn-circle"
      size="sm"
      text="Ver"
    >
      <Icon icon="eye" />
    </ButtonTooltip>
  );

  if (item.status !== 'pending') {
    return viewButton;
  }

  const deleteButton = canDestroy ? (
    <ButtonTooltip
      onClick={() => clickHandler(item, 'destroy')}
      variant="circle-danger"
      className="btn-circle"
      size="sm"
      text="Eliminar"
    >
      <Icon icon="trash" />
    </ButtonTooltip>
  ) : null;

  if (isMyTurn && hasPermission && isOwnerView) {
    return (
      <>
        {viewButton}
        <ButtonTooltip
          onClick={() => clickHandler(item, 'approve')}
          variant="circle-success"
          className="btn-circle"
          size="sm"
          text="Aprobar"
        >
          <Icon icon="checkmark-circle" />
        </ButtonTooltip>

        <ButtonTooltip
          onClick={() => clickHandler(item, 'reject')}
          variant="circle-warning"
          className="btn-circle"
          size="sm"
          text="Rechazar"
        >
          <Icon icon="close-circle" />
        </ButtonTooltip>

        {deleteButton}
      </>
    );
  }

  return (
    <>
      {viewButton}
      {deleteButton}
    </>
  );
};

let isOwnerView = true;
let currentUserEmployee = null;

export const setColumnsContext = (isOwner, employeeId) => {
  isOwnerView = isOwner;
  currentUserEmployee = employeeId;
};

const columns = memoize(clickHandler => [
  {
    name: 'Fecha de Solicitud',
    selector: 'created_at',
    sortable: true,
    center: true
  },
  {
    name: 'Fecha Inicio',
    selector: 'start_date',
    sortable: true,
    center: true
  },
  {
    name: 'Fecha Término',
    selector: 'end_date',
    sortable: true,
    center: true
  },
  {
    name: 'Fecha Retorno',
    selector: 'reincorporation_date',
    sortable: true,
    center: true
  },
  {
    name: 'Días',
    selector: 'days_taken',
    sortable: true,
    center: true
  },
  {
    name: 'Horas Extras',
    selector: 'extra_hours_taken',
    sortable: true,
    center: true
  },
  {
    name: 'Estado de la solicitud',
    selector: 'translated_status',
    center: true
  },
  {
    name: 'Acciones',
    cell: item => (
      <WorkflowActionButtons
        item={item}
        clickHandler={clickHandler}
        isOwnerView={isOwnerView}
        currentEmployee={currentUserEmployee}
      />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    minWidth: '200px'
  }
]);

export default columns;
